export default __webpack_public_path__ + "static/bg-096428e9e028fdfa8b76a59315058df0.jpg";